import React, { useEffect } from 'react'
import './activities.css'
import profile from '../../assets/profile.png'
import { Link } from 'react-router-dom'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'
import { fetchPosts } from '../../api/postApi'
import { postState } from '../../state/postSlice'


const Activities = ({home}) => {
    const {user} = useSelector((state)=>state.user)
    const {post} = useSelector((state)=>state.post)
    const dispatch = useDispatch()

    const handleGetPost = async ()=>{
        try {
            const res = await fetchPosts(user?.token)
            dispatch(postState(res?.data))
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(()=>{
        handleGetPost()
    },[])

  return (
    <div className="activities__box">
        <div className="activities__heading">
            <h4 className="activities__heading-title">Recent Activities</h4>
            <Link to='/news_stand'
            className='activities__heading-link'>View all</Link>
        </div>
        <div className="activities__item">
            {
                post?.slice(0, 2)?.map((item, i)=>(
                    <div className="activities__profile" key={i}>
                        <img src={profile} alt="" className="activities__profile-img" />
                        <div className="activities__profile-body">
                            <h4 className="activities__profile-name">
                                {item?.user?.firstName + ' ' + item?.user?.lastName}
                            </h4>
                            <p className="activities__profile-desc"
                            dangerouslySetInnerHTML={{ __html: item?.description?.length > 80 ?
                                item?.description?.slice(0, 80)+'...' : item?.description }}>
                            </p>
                            <span className="activities__profile-time">
                                {moment(item?.createdAt).fromNow()}
                            </span>
                        </div>
                    </div>
                ))
            }
        </div>
    </div>
  )
}

export default Activities